<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <div class="card">
                <div class="card card-custom" >
                    <div class="card-header flex-wrap border-0 pt-6 pb-0">
                    <div class="card-title">
                        <h3 class="card-label">{{ $t('attributes.list') }}</h3>
                    </div>
                    <div class="card-toolbar">
                        <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_ATTRIBUT)" type="new" btn-text="attributes.create" @click="openAttributeModal"/>
                    </div>
                    </div>
            
                    <div class="card-body" >
                    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_attributes" style="margin-top: 13px !important; cursor:pointer">
                        <thead>
                        <tr class="text-start fw-bolder fs-7 text-uppercase gs-0" style="background-color: #F2F3F4;">
                            <th> {{$t("attributes.name")}}</th>
                            <th> {{$t("attributes.values")}}</th>
                            <th> {{$t("actions")}}</th>
                            </tr>
                        </thead>
                    </table>
                    </div>
                </div>
                <CreateAttribute id="create" @load="fetchDatas"></CreateAttribute>
                <CreateAttribute id="edit" :attribut="formUpdateData" @load="fetchDatas"></CreateAttribute>

                <CreateAttributeValues :attribut-value="formAddValuesData" id="add" @load="fetchDatas"></CreateAttributeValues>
                <CreateValue id="edit" :values="formUpdateValueData" @load="fetchDatas"></CreateValue>
            </div>
        </template>
    </SubLayout>
</template>

<script setup>
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
    import {nextTick, onMounted, ref, watch} from "vue";
    import i18n from '@/plugins/i18n';
    import CreateAttribute from '@/components/Attribute/CreateAttribute.vue'
    import CreateAttributeValues from '@/components/Attribute/CreateAttributeValues.vue'
    import CreateValue from '@/components/Values/CreateValue.vue'
    import {BASE_URL} from "@/services/api";
    import {useStore} from "vuex";
    import {useHasAbility} from "@/composables/hasAbility";
    import { useLocales } from "@/composables/locales"; 
    import Button from "@/components/Button.vue"
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";
    import {Theme} from "@/composables/theming";
    import Ls from "@/services/ls";

    const title = ref("breadcrumbs.attributes.title")
    const breadcrumbs = ref([
        {
            name: 'breadcrumbs.attributes.list',
            route: 'attributes'
        }
    ])
    const { can } = useHasAbility()
    const store = useStore()
    const {showSwal} = useSwal()

    const {locale, datatableLocaleUrl} = useLocales()

    const table = ref()

    const formAddValuesData = ref({
        attribut: "",
        value: []
    })

    const formUpdateData = ref({
        id: "",
        name: ""
    })

    const formUpdateValueData = ref({
        variation: '',
        attribut_id: '',
        name: ''
    })

    const formDeleteValueData = ref({
        variation: ""
    })

    onMounted(() => {
        fetchDatas()
    })

    watch(() => locale.value, () => {
      nextTick(() => fetchDatas() )
    })

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')
        const pageLimit = Ls.get('pageLength')

        table.value = $("#kt_datatable_attributes").DataTable({
            destroy: true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength: pageLimit ||  5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 0, 'asc']],
            ajax: {
            url: BASE_URL + "/get/attributs/datatables",
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
              request.setRequestHeader("Company", Ls.get('current.company'));
            }
            },
            columns: [
            { data: "name" },
            { data: "variations" },
            { data: "Actions", responsivePriority: -1 }
            ],
            columnDefs: [
            {
                targets: -3,
                orderable:false,
                searchable:false,
                className: "dt-center clickable" ,
                render: function (t) {
                return '<span >' + t + "</span>";
                },
            },
            {
                targets: -2,
                orderable:false,
                searchable:false,
                className: "dt-center clickable" ,
                render: function (t, a, e, l) {
                  let result = ''
                  for (let element in t) {
                    let canDeleteVariation = can(abilities.DELETE_VARIATION)
                        ? `<i class="fas fa-times delete_variation_btn" style="color: var(--bs-primary);" data-id="${e.id }"
                         data-value_id="${element}" data-value="${element}"></i>`
                        : ``
                    result += '<span class="badge badge-light-primary" style="margin-right: 5px;"><span class="edit_value_btn" style="margin-right: 5px;" data-id="' + e.id + '" data-value_id="' + element + '" data-value="' + t[element] + '">' + t[element] + '</span> ' + canDeleteVariation + '</span>';
                  }
                  ;
                  return result
                },
            },
              {
                width: "20%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: function(t, a, e, l) {
                let render=""
                if(can(abilities.CREATE_VARIATION)){
                    render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'"  data-name="'+ e.name +'" class="btn btn-sm btn-clean btn-icon add_value_btn" title="add value"><i  data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" class="fas fa-plus" style="color: '+Theme.gray +'"></i></a>'
                }
                if(can(abilities.UPDATE_ATTRIBUT)){
                    render += '<a href="javascript:;"    data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit_attribut') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'"  class="fas fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'
                }
                if(can(abilities.DELETE_ATTRIBUT)){
                    render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
                }
                return render
                },
            },
            ],
            language: {
            url: datatableLocaleUrl.value,
            }
        });

        $(document).on("click", "#kt_datatable_attributes .add_value_btn", (e) => {
            formAddValuesData.value.attribut = e.target.getAttribute('data-id')
            $('#createAttributeValuesModal_add').modal('toggle')
        });

        $(document).on("click", "#kt_datatable_attributes .edit_btn", (e) => {
            formUpdateData.value.id = e.target.getAttribute('data-id')
            formUpdateData.value.name = e.target.getAttribute('data-name')
            $('#createAttributeModal_edit').modal('toggle')
        });

        $(document).on("click", "#kt_datatable_attributes .edit_value_btn", (e) => {
            if(can(abilities.UPDATE_VARIATION)){
                formUpdateValueData.value.attribut_id = e.target.getAttribute('data-id')
                formUpdateValueData.value.variation = e.target.getAttribute('data-value_id')
                formUpdateValueData.value.name = e.target.getAttribute('data-value')
                $('#createValueModal_edit').modal('toggle')
            }
        });

        $(document).on("click", "#kt_datatable_attributes .delete_btn", (e) => {
            let id = e.target.getAttribute('data-id')
            deleteAttribute(id)
        });

        $(document).on("click", "#kt_datatable_attributes .delete_variation_btn", (e) => {
            if(can(abilities.DELETE_VARIATION)){
                formDeleteValueData.value.variation = e.target.getAttribute('data-value_id')
                deleteValue()
            }
            
        });
    }

    function openAttributeModal() {
        $('#createAttributeModal_create').modal('toggle')
    }

    async function deleteAttribute(id) {
        showSwal(
            i18n.global.t('swal.title'),
            i18n.global.t('swal.attribute_deleted')
        ).then( async (result) => {
            if (result.value) {
                store.dispatch('attributs/deleteAttribut', id).then((res) => {
                    table.value.ajax.reload()
                    window.toastr['success'](i18n.global.t('notification.attribute_deleted'))
                }).catch(() => {

                })
            }
        })
    }

    async function deleteValue() {
        showSwal(
            i18n.global.t('swal.title'),
            i18n.global.t('swal.value_deleted')
        ).then( async (result) => {
            if (result.value) {
                store.dispatch('variations/deleteVariation', formDeleteValueData.value).then((res) => {
                    table.value.ajax.reload()
                    window.toastr['success'](i18n.global.t('notification.values_deleted'))
                }).catch(() => {

                })
            }
        })
    }
</script>

<style scope>
.badge-light-primary {
    color: var(--bs-primary);
    background-color: var(--bs-light-primary);
}
</style>